<script lang="ts">
	import { scrollY } from '$lib/stores/resizeStore';
	import ParallaxHeader from '$lib/components/cover/ParallaxHeader.svelte';
	import HubLogo from '$lib/components/cover/HubLogo.svelte';
	import CoverTitle from '$lib/components/cover/CoverTitle.svelte';
	import WelcomeMessage from '$lib/components/cover/WelcomeMessage.svelte';
	import UsersContainer from '$lib/components/cover/usersContainer/UsersContainer.svelte';
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';
	import type { Device } from '$lib/types/Device';

	export let hub: Writable<Hub>;
	export let forDesignPage = false;
	export let device: Device;

	$: contentAlignLeft = device == 'desktop' && $hub.theme.desktop.alignment == 'left';
	$: hubLogoUrl =
		device == 'desktop'
			? $hub.theme.desktop.coverLogoImage.url
			: $hub.theme.mobile.coverLogoImage.url;

	$: hubLogoHeight =
		device == 'desktop'
			? $hub.theme.desktop.coverLogoImage.height
			: $hub.theme.mobile.coverLogoImage.height;

	// Convert the scrollY value to a percentage of the cover height
	$: backgroundOpacity = forDesignPage ? 1 : 1 - Math.min($scrollY / 430, 1);
</script>

<div class="px-cover">
	<div class="px-hub-parallax-header-wrapper" style="opacity:{backgroundOpacity}">
		<ParallaxHeader {forDesignPage} {hub} {device}>
			<div class="headerContent">
				<div
					class="px-hub-cover-container"
					class:contentAlignLeft
					style="transform:translateY({forDesignPage ? 0 : $scrollY / 3.5}px);">
					{#if hubLogoUrl}
						<div class="px-cover-logo">
							<HubLogo {hubLogoUrl} {hubLogoHeight} />
						</div>
					{/if}
					{#if $hub.theme.coverShowTitle}
						<CoverTitle {hub} />
					{/if}
					<WelcomeMessage {hub} />
					{#if !$hub.theme.coverHideAvatarsAndCounterPill}
						<UsersContainer {hub} />
					{/if}
				</div>
			</div>
		</ParallaxHeader>
	</div>
</div>

<style>
	.px-hub-parallax-header-wrapper {
		background-color: var(--coverBackgroundColor);
	}

	.px-cover {
		background-color: var(--headerBackgroundColor);
	}

	.px-cover-logo {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.px-hub-cover-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		opacity: 1;
	}

	.contentAlignLeft {
		align-items: flex-start;
		block-size: auto;
		inline-size: 100%;
		padding-block: 0;
		padding-inline: var(--gutterLarge);
	}

	.headerContent {
		display: flex;
		position: relative;
		justify-content: center;
		block-size: var(--COVER_HEIGHT);
		overflow: hidden;
	}
</style>
